<template lang="pug">
.ma-3
  v-dialog(v-model='isChangeCustomer'  width='350' min-height="500" :persist="isLoadingCambiarRuc")
    v-card.pa-4
      .px-4.pt-4
        .font-weight-700.font-size-18 Parametros
      .px-4.ai-center.jc-center.pb-4.fd-column.pt-2
        span.font-size-11  Ingrese el ruc de un cliente con contrato
        .d-flex.ai-center.mb-4
          v-text-field.mt-1(
            dense,
            v-model="rucEditCliente"
            hide-details
            type='number'
            :placeholder="`Numero de ruc`"
            solo
          )
          v-btn(color='info'    @click='fetchCambiarRUCCuenta()' :disabled="isNaN(rucEditCliente) || rucEditCliente.length < 11 || rucEditCliente.length > 11" :loading="isLoadingCambiarRuc")
            v-icon check
        strong.font-size-15 {{nombreEditCliente}}

      v-card-actions
        v-btn(color='primary'  block  @click='fetchCambiarRUCCuenta(true)' :loading="isLoadingCambiarRuc" :disabled="isNaN(rucEditCliente) || rucEditCliente.length < 11 || rucEditCliente.length > 11")
          small Guardar cambios
  v-card.mx-auto.pa-3.flex.fd-column(elevation='1')
    .d-flex.ai-center
      .flex.fd-column
        small.font-size-11 Tipo de ticket que desea generar
        v-slide-group.flex-1(
          v-model='tipoTicket'
          mandatory
          show-arrows=''
        )
          v-slide-item.animated.fadeInLeft.faster(
            v-for='(n, index) in categoriasTicket'
            :value="n.value"
            :key='index'
            v-slot='{ active, toggle }'
          )
            v-card.elevation-1.ma-1.d-flex.ai-center.jc-center.text-center(
              :color="active ? 'primary' : 'secondary primary--text'"
              height='60',
              :dark="active"
              width='140'
              @click='toggle'
            )
              span.font-size-12.font-weight-600 {{n.name}}
      .d-flex.fd-column.px-2(v-if="usuarioLogged && usuarioLogged.puedeCambiarRucDeCliente")
        v-btn(
          color="primary",
          :loading="isLoadingProceso"
          @click="openDialogIsChangeCustomer()",
          :small="!isMovil",
          :block="isMovil"
        )
          | Cambiar cliente


    .pa-1.d-flex.ai-center.jc-center
      .fd-column.flex-1
        .d-flex.fd-column(v-if="!ruc || perfilUsuario === 'dispatcher'")
          .d-flex.mb-3.ai-center.jc-center
            small.font-size-11 Ingrese un valor valido
            .flex-1.d-flex.justify-end
              v-radio-group.mt-0(  hide-details row v-model="tipoFiltroBusquedaEquipo" )
                v-radio(label="Serie", value='serie' hide-details )
                v-radio(label="RUC", value='ruc' hide-details )
          .d-flex
            v-text-field.mb-4(v-if="tipoFiltroBusquedaEquipo === 'ruc'" solo  dense type="number" ref="documento"  label="Ingrese un numero de ruc valido" v-model="ruc" @keyup.enter="fetchEquipos()" hide-details)
            v-text-field.mb-4(v-else-if="tipoFiltroBusquedaEquipo === 'serie'" solo  dense type="text" ref="serie"  label="Ingrese una serie valida" v-model="serieFiltro" @keyup.enter="fetchEquipos()" hide-details)
            v-btn(color='info' :block="isMovil"  @click="fetchEquipos()")
              | buscar
        .d-flex.fd-column.mb-4(v-if="usuariosContrato.length && perfilUsuario === 'dispatcher '")
          span.font-size-11
            | Cuentas registradas para este cliente
          v-radio-group.mt-0(v-model="usuarioSeleccionado"  hide-details v-if="usuarioSeleccionado.length > 1")
            v-radio(:label="`${usuario.razonSocial} (${usuario.usuario})`", :value='usuario.usuario' v-for="(usuario, index) in usuariosContrato" :key="index" hide-details )
        .d-flex.mb-1(v-if="modelosAgrupados.length")
          small.font-size-11 Listado de equipos en contrato
        .d-flex(v-if="modelosAgrupados.length")
          .flex-1(v-if="!modelosAgrupadosFiltrados.length")
            v-autocomplete(
              :loading="isGettingEquipos"
              :items='modelosAgrupados'
              v-model="equiposDelModelo"
              label="Listado de modelos que tienes en contrato"
              placeholder="Realiza la busqueda por el modelo"
              item-value="equipos"
              dense,
              hide-details,
              solo,
            )
              template(v-slot:selection='data')
                  span.font-weight-700.font-size-12 {{ data.item.modelo }}
              template(v-slot:item='data')
                v-list-item-content
                  v-list-item-title.font-weight-700(v-html='data.item.modelo')
                  v-list-item-subtitle
                    span.font-size-11.text-muted {{`${data.item.cantidad} Equipo(s)`}}
          .flex-1(v-else)
            //- span {{modelosAgrupadosFiltrados}}
            .d-flex.ai-center(:class="isMovil && 'fd-column'")
              v-btn(color="info", @click="limpiarModelo()" :class="isMovil && 'mb-2'")
                v-icon keyboard_arrow_left
              v-autocomplete(
                :items='modelosAgrupadosFiltrados'
                :label="`Listado de equipos del modelo`"
                placeholder="Realiza la busqueda por la descripción"
                dense,
                item-value="serie"
                item-text="serie"
                return-object
                hide-details,
                solo,
                @change="agregarNuevoTicket"
              )
                template(v-slot:item='data')
                  v-list-item-content
                    v-list-item-title.font-weight-700(v-html='data.item.serie')
                    v-list-item-subtitle
                      span.font-size-11 {{data.item.descripcionArticulo}}
    .box-new-ticket.pa-1
      .elevation-0.py-0.mt-2.px-0
        v-list-group.border-bottom-2px(v-for='(t, index) in tickets', :key='index', v-model='t.active', :class="{'pb-3 background' : t.active }")
          template(v-slot:activator='')
            v-list-item-content.px-0.py-0
              v-list-item-title
                v-list.py-2(dense, :color="t.active ? 'background' : ''")
                  v-list-item
                    v-list-item-avatar(color="primary")
                      v-icon(color="white") print
                    v-list-item-content.py-0
                      v-list-item-title
                        span.font-weight-700 {{ `#${t.numeroContrato}` }} - &nbsp;
                        span.font-weight-700 {{ t.modelo }} - &nbsp;
                        span.font-weight-700.primary--text {{t.serie}}
                      v-list-item-subtitle.info--text.font-weight-700 {{t.descripcion}}
                      v-list-item-subtitle.font-weight-700(v-if="!t.active") {{t.direccion}} - ({{t.distrito}} - {{t.provincia}} - {{t.departamento}})
                    v-list-item-action
                      v-btn(color="error", small, @click.stop="eliminarItemSerie(index)")
                        v-icon(size="17") delete
                        span Eliminar
          v-list-item.px-4(:key='index')
            v-list-item-content.py-0
              .mt-0(v-if="tipoTicket === 'solicitud de insumo' && t.clasificacion" )
                small.font-size-11 Insumos disponibles para el equipo {{ t.clasificacion }}
                v-radio-group.mb-2(v-if="t.incluyePapel && t.clasificacion === 'multifuncional'" v-model='t.grupoPedidoInsumo', row='' hide-details @change="(valor) => recalcularInsumos(t)")
                  v-radio(label='Consumible', value='consumible')
                  v-radio(label='Papel', value='papel')
                .d-flex.fd-column.my-2(v-if="t.grupoPedidoInsumo === 'consumible'")
                  .d-flex.ai-center(v-for='(item, i) in t.insumo')
                    v-checkbox.ma-0(v-model='item.active' :name="item.code"  :id="item.code" color='primary'  hide-details )
                    label.font-size-11(:class="{'!primary--text font-weight-700' : item.active}" :for="item.code") {{ item.name}}
                .d-flex.fd-column.mb-2(v-if="t.grupoPedidoInsumo === 'papel'")
                  small.font-size-11.primary--text Se solicitará papel para el equipo seleccionado

              .mt-0(v-if="tipoTicket === 'incidencia con equipo'")
                span.font-size-11  ¿Cual es la falla que presenta el equipo?
                v-select.mt-1(
                  :loading="isGettingFallas"
                  dense,
                  hide-details
                  item-text="descripcionFallaGeneral"
                  item-value="codigoFallaGeneral"
                  v-model='t.falla'
                  return-object
                  :items='fallas'
                  :placeholder="`Listado de fallas para la serie ${t.serie}`"
                  solo
                )
              .mt-0(v-if="tipoTicket === 'solicitud de insumo' && t.serie")
                v-text-field(
                  v-model="t.direccion"
                  dense,
                  hide-details
                  placeholder="Ingresa una dirección valida"
                  solo
                )

              .mt-0(v-if="tipoTicket === 'solicitud de insumo'")
                small.font-size-11  Departamento
                v-autocomplete.mt-1(v-model='t.departamento' :items='t.departamentos' @change="rellenarInformacion('departamento', index)"  dense=''  label='Departamento'  hide-details solo)
              .mt-0(v-if="tipoTicket === 'solicitud de insumo'")
                small.font-size-11  Provicia
                v-autocomplete.mt-1(v-model='t.provincia' :items='t.provincias'  dense='' @change="rellenarInformacion('provincia', index)"  label='Provincia'   hide-details solo)
              .mt-0(v-if="tipoTicket === 'solicitud de insumo'")
                small.font-size-11  Distrito
                v-autocomplete.mt-1(v-model='t.distrito' :items='t.distritos'  dense=''  @change="rellenarInformacion('distrito', index)"  label='Distrito'  hide-details solo)
              .mt-0(v-if="tipoTicket === 'solicitud de insumo' && t.serie" )
                small.font-size-11  Nombre completo de la persona de contacto
                v-text-field.mt-1(
                  v-model="t.nombreContacto"
                  dense,
                  hide-details
                  placeholder="Ingresa el nombre del contacto"
                  solo
                )
              .mt-0(v-if="tipoTicket === 'solicitud de insumo' && t.serie")
                small.font-size-11  Numero de telefono celular de la persona de contacto
                v-text-field.mt-1(
                  v-model="t.numeroTelefono"
                  dense,
                  hide-details
                  placeholder="Ingresa el numero de telefono  del contacto"
                  solo
                  type="number"
                )
              .mt-0(v-if="tipoTicket === 'solicitud de insumo' && t.clasificacion === 'multifuncional'")
                small.font-size-11  Contador actual del equipo (opcional)
                v-text-field.mt-1(
                  v-model="t.contadorActual"
                  dense,
                  hide-details
                  placeholder="Ingresa el contador actual"
                  solo
                  type="number"
                )
              v-alert.my-4(
                v-if="t.tipo === 'incidencia con equipo'"
                icon='warning'
                type='warning'
                text
              )
                .d-flex.fd-column
                  span.font-size-14.font-weight-700 Explicanos un poco más de la falla de tu equipo
                  small.font-size-11 Ejemplos
                  small.font-size-11 - La parte superior izquierda de la hoja sale manchada de rojo
                  small.font-size-11 - Si el equipo mostrara un código de error, por favor ingreselo aquí
              v-alert.my-4(
                v-else
                icon='info'
                type='info'
                text
              )
                .d-flex.fd-column
                  span.font-size-14.font-weight-700 Alguna observación adicional
                  small.font-size-11 Ejemplos
                  small.font-size-11 - Acercarse de 2pm a 6pm que se encuentra el encargado
                  small.font-size-11 - Solo enviar el color negro y amarillo
              div
                small.font-size-11  Ingrese un comentario adicional (opcional)
                v-textarea(
                  v-model='t.comentarioGeneral'
                  placeholder='Comentario adicional  (opcional)'
                  solo,
                  dense,
                  rows="4"
                )
    v-divider
    .d-flex.pa-3
      v-spacer
      v-btn(
        :disabled="!tickets.length"
        color="success",
        @click="procesoGenerarTickets()",
        :small="!isMovil",
        :block="isMovil"
        :loading="isLoadingProceso"
      )
        | Generar ticket
</template>

<script>
import Router from '../router/dispatcher.js'
import { apiGet, apiPost, notify } from '../util/general'
import adjuntarArchivos from './c_adjuntar_archivos'
export default {
  name: 'nuevo_ticket_contrato',
  components: {
    'adjuntar-archivos' : adjuntarArchivos
  },
  data () {
    return {
      isGettingFallas      : false,
      isLoadingUbigeos      : false,
      isChangeCustomer      : false,
      isLoadingProceso      : false,
      tipoFiltroBusquedaEquipo               : 'ruc',
      serieFiltro : '',
      fallas               : [],
      listaInsumos               : [],
      clasificacion               : '',
      tiposEquipo          : [],
      categoriasTicket         : [
        {
          name : 'Incidencia con equipo',
          value: 'incidencia con equipo'
        },
        {
          name : 'Solicitud de insumo',
          value: 'solicitud de insumo'
        }
      ],
      tipoTicket : 'incidencia con equipo',
      usuario         : localStorage.getItem('username'),
      perfilUsuario         : localStorage.getItem('perfil'),
      ruc         : localStorage.getItem('ruc'),
      nombreCliente         : localStorage.getItem('razonSocial'),
      ubigeos :[],
      isGettingEquipos     : false,
      modelosAgrupados     : [],
      tickets     : [],
      usuariosContrato     : [],
      departamentos     : [],
      equiposDelModelo     : [],
      // modeloSeleccionado   : '',
      isLoadingDirecciones: false,
      isLoading: false,
      isLoadingCambiarRuc: false,
      rucEditCliente : 0,
      nombreEditCliente : '',
      usuarioLogged : null,
      usuarioSeleccionado : null
    }
  },
  created () {
    var vm = this
    vm.fetchGetDataUser()
    vm.fetchUbigeos(err => {
      if (err) notify(vm, 'error', 'Error', err.message)
    })
    if (vm.ruc) {
      vm.tipoFiltroBusquedaEquipo = 'ruc'
      vm.fetchEquipos()
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    },
    modelosAgrupadosFiltrados () {
      var vm = this
      var seriesAgregados = vm.tickets.map(e => e.serie)
      return vm.equiposDelModelo.filter(e => !seriesAgregados.includes(e.serie))
    }
  },
  watch : {
    tipoTicket (val) {
      var vm = this
      for (var i = 0; i < vm.tickets.length; i++) {
        vm.tickets[i].tipo = val
        vm.tickets[i] = vm.recalcularInsumos(vm.tickets[i])
      }
    }
  },
  methods: {
    fetchGetDataUser () {
      var vm = this
      vm.isLoading = true
      var obj      = {
        usuario : vm.usuario
      }
      apiGet(vm, '/usuario/obtener', obj, function (data) {
        vm.usuarioLogged = data.lista[0]
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, () => {
        vm.isLoading = true
      })
    },
    openDialogIsChangeCustomer () {
      var vm = this
      vm.rucEditCliente = localStorage.getItem('ruc')
      vm.nombreEditCliente = localStorage.getItem('razonSocial')
      vm.isChangeCustomer       = true
    },
    closeDialogIsChangeCustomer () {
      var vm = this
      vm.rucEditCliente = 0
      vm.nombreEditCliente = ''
      vm.isChangeCustomer       = false
    },
    limpiarModelo () {
      var vm = this
      vm.equiposDelModelo       = []
    },
    fetchEquipos () {
      var vm = this
      if (vm.tipoFiltroBusquedaEquipo === 'ruc' && !vm.ruc) return notify(vm, 'error', 'Error', 'El numero de ruc es invalido')
      if (vm.tipoFiltroBusquedaEquipo === 'serie' && !vm.serieFiltro) return notify(vm, 'error', 'Error', 'El codigo de la serie es invalido')
      vm.isGettingEquipos = true
      vm.$store.dispatch('transaccion', { isProceso : true, message : `Obteniendo listado de equipos` })
      var obj = {
        ruc: vm.ruc,
        serie : vm.serieFiltro
      }
      apiGet(vm, '/cliente/serie/agrupado/all', obj, function (data) {
        vm.modelosAgrupados = data.equiposAgrupados
        var rucFilter = vm.tipoFiltroBusquedaEquipo === 'ruc' ? vm.ruc : data.ruc
        vm.verificarUsuarioAntesCrearTicket(rucFilter, function (err, usuarios) {
          if (err) {
            notify(vm, 'error', 'Error', err.message)
            vm.isLoadingProceso = false
            return;
          }

          vm.usuariosContrato = usuarios
          vm.usuarioSeleccionado = usuarios[0].usuario

          if (vm.tipoFiltroBusquedaEquipo === 'serie' && vm.modelosAgrupados.length) {
            vm.equiposDelModelo = vm.modelosAgrupados[0].equipos
            vm.agregarNuevoTicket(vm.equiposDelModelo[0])
          }
          vm.isGettingEquipos = false
          vm.$store.dispatch('transaccion', { isProceso : false })
        })
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.isGettingEquipos = false
        vm.$store.dispatch('transaccion', { isProceso : false })
      }, function () {
      })
    },
    verificarUsuarioAntesCrearTicket (ruc, callback) {
      var vm = this
      var obj = {
        ruc: ruc
      }
      apiGet(vm, '/usuario/obtener/por/ruc', obj, function (data) {
        callback(null, data.usuarios || [])
      }, function (error) {
        callback(error)
      })
    },
    fetchUbigeos (callback) {
      var vm  = this
      vm.isLoadingUbigeos = true
      var obj = {}
      apiGet(vm, '/ubigeo/obtener', obj, function (data) {
        vm.ubigeos = data.lista
        for (var i = 0; i < data.lista.length; i++) {
          if (!vm.departamentos.includes(data.lista[i].departamento)) vm.departamentos.push(data.lista[i].departamento)
        }
        callback && callback()
      }, function (error) {
        callback ? callback(error) :  notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingUbigeos = false
      })
    },
    rellenarInformacion (tipo, index) {
      var vm = this
      if (tipo === 'departamento') {
        vm.tickets[index].provincias = []
        vm.tickets[index].provincia = ''
        vm.tickets[index].distritos  = []
        vm.tickets[index].distrito = ''
      } else if (tipo === 'provincia') {
        vm.tickets[index].distritos  = []
        vm.tickets[index].distrito = ''
      }

      for (var i = 0; i < vm.ubigeos.length; i++) {
        if (tipo === 'departamento') {
          if (vm.tickets[index].departamento === vm.ubigeos[i].departamento) {
            vm.tickets[index].provincias.push(vm.ubigeos[i].provincia)
          }
        } else if (tipo === 'provincia') {
          if (vm.tickets[index].provincia === vm.ubigeos[i].provincia) {
            vm.tickets[index].distritos.push(vm.ubigeos[i].distrito)
          }
        }
      }

      if (vm.tickets[index].departamento && vm.tickets[index].provincia && vm.tickets[index].distrito) {
        vm.tickets[index].ubigeo = vm.ubigeos.find(e => e.descripcion === `${vm.tickets[index].departamento}-${vm.tickets[index].provincia}-${vm.tickets[index].distrito}`).ubigeo
      } else vm.tickets[index].ubigeo = ''
    },
    goTo (page) {
      Router.push(page)
    },
    fetchFallas (tipoProductoMaquina) {
      var vm = this
      vm.isGettingFallas = true
      var obj = {
        codigoTipoEquipo: tipoProductoMaquina
      }
      apiGet(vm, '/falla/por/tipo/producto', obj, function (data) {
        vm.fallas = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isGettingFallas = false
      })
    },
    procesoGenerarTickets () {
      var vm = this
      vm.isLoadingProceso = true
      vm.validarValoresAntesGenerarTicket(function () {
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Generando tickets datos...' })
        vm.guardarTicketRecursivo(0, (err) => {
          if (err) {
            notify(vm, 'error', 'Error', err.message)
            vm.$store.dispatch('transaccion', { isProceso : false })
            vm.isLoadingProceso = false
            return
          }

          vm.isLoadingProceso = false
          vm.$store.dispatch('transaccion', { isProceso : false })

          if (vm.tickets.length === 1) {
            notify(vm, 'success', 'Exito', 'El ticket  se generó correctamente')
            vm.goTo(`/ticket/${vm.tickets[0].numero}`)
          } else {
            notify(vm, 'success', 'Exito', 'Los tickets se generarón correctamente')
            vm.goTo('/tickets')
          }
        })
      })
    },
    guardarTicketRecursivo (index, callback) {
      var vm = this
      vm.fetchGuardarTicket(vm.tickets[index], (err, response) => {
        if (err) callback(err)
        else {
          vm.tickets[index].numero = response.numero
          index++
          if (index === vm.tickets.length) callback(null)
          else vm.guardarTicketRecursivo(index, callback)
        }
      })
    },
    fetchGuardarTicket (ticket, callback) {
      var vm = this
      var obj = {
        ticket     : {
          ...ticket,
          usuario : vm.usuarioSeleccionado,
          insumo : ticket.insumo.filter(e => e.active).map(e => e.name)
        },
        isGenerarIT : vm.perfilUsuario !== 'dispatcher',
        isPlantilla : vm.perfilUsuario === 'dispatcher' ? 1 : 0
      }

      apiPost(vm, '/ticket/registrar', obj, function (data) {
        callback(null, data)
      }, function (error) {
        callback(error)
      })
    },
    validarValoresAntesGenerarTicket (callback) {
      var vm = this
      for (var i = 0; i < vm.tickets.length; i++) {
        var ticket = vm.tickets[i];
        vm.tickets[i].tipo = vm.tipoTicket

        if (!ticket.tipo) {
          notify(vm, 'error', 'Error', `Para la serie ${ticket.serie}, Por favor seleccione una categoria para el ticket`)
          vm.isLoadingProceso = false
          return;
        }

        if (!ticket.serie) {
          notify(vm, 'error', 'Error', `Para la serie ${ticket.serie}, Por favor seleccione una serie`)
          vm.isLoadingProceso = false
          return;
        }

        if (ticket.tipo === 'incidencia con equipo') {
          if (!ticket.falla.codigoFallaGeneral) {
            notify(vm, 'error', 'Error', `Para la serie ${ticket.serie}, Por favor seleccione una falla`)
            vm.isLoadingProceso = false
            return;
          }
        }

        if (ticket.tipo === 'solicitud de insumo') {
          if (!ticket.direccion) {
            notify(vm, 'error', 'Error', `Para la serie ${ticket.serie}, Por favor ingrese una direccion para el destino del insumo`)
            vm.isLoadingProceso = false
            return;
          }
          if (!ticket.departamento) {
            notify(vm, 'error', 'Error', `Para la serie ${ticket.serie}, Por favor seleccione un departamento`)
            vm.isLoadingProceso = false
            return;
          }
          if (!ticket.provincia) {
            notify(vm, 'error', 'Error', `Para la serie ${ticket.serie}, Por favor seleccione una provincia`)
            vm.isLoadingProceso = false
            return;
          }
          if (!ticket.distrito) {
            notify(vm, 'error', 'Error', `Para la serie ${ticket.serie}, Por favor seleccione un distrito`)
            vm.isLoadingProceso = false
            return;
          }
          if (!ticket.nombreContacto) {
            notify(vm, 'error', 'Error', `Para la serie ${ticket.serie}, Por favor ingrese el nombre de un contacto para recepcionar los insumos.`)
            vm.isLoadingProceso = false
            return;
          }
          if (!ticket.numeroTelefono) {
            notify(vm, 'error', 'Error', `Para la serie ${ticket.serie}, Por favor ingrese el numero de telefono del contacto para recepcionar los insumos.`)
            vm.isLoadingProceso = false
            return;
          }
        }
      }
      callback && callback()
    },
    clearSerie () {
      var vm = this
      vm.ticket.serie          = ''
      vm.ticket.tipoProductoMaquina = ''
      vm.ticket.descripcionTipoEquipo = ''
      vm.fallas = []
    },
    limpiarSerie () {
      var vm = this
      vm.$emit('clear')
    },
    eliminarItemSerie (index) {
      var vm = this
      vm.tickets = vm.tickets.filter((e, i) => i !== index)
    },
    agregarNuevoTicket (serieSeleccionado) {
      var vm = this
      var nuevaSerie = {}
      nuevaSerie.tipo = vm.tipoTicket
      nuevaSerie.active = true
      nuevaSerie.insumo = []
      nuevaSerie.serie      = serieSeleccionado.serie
      nuevaSerie.modelo     = serieSeleccionado.modelo
      nuevaSerie.descripcion     = serieSeleccionado.descripcionArticulo
      nuevaSerie.direccion     = serieSeleccionado.direccionMaquina
      nuevaSerie.clasificacion = ''
      nuevaSerie.ubigeo = serieSeleccionado.ubigeo
      nuevaSerie.esColor = serieSeleccionado.esColor
      nuevaSerie.codigoArticuloSap = serieSeleccionado.codigoArticuloSap
      nuevaSerie.incluyePapel = serieSeleccionado.incluyePapel
      nuevaSerie.numeroContrato = serieSeleccionado.numeroContrato
      nuevaSerie.departamentos = vm.departamentos
      nuevaSerie.provincias = []
      nuevaSerie.distritos = []
      nuevaSerie.departamento = ''
      nuevaSerie.falla = {
        codigoFallaGeneral : 0,
        descripcionFallaGeneral : ''
      }
      nuevaSerie.provincia = ''
      nuevaSerie.distrito = ''
      nuevaSerie.grupoPedidoInsumo = 'consumible'
      nuevaSerie.tipoProductoMaquina = serieSeleccionado.codigoArticuloSap ? serieSeleccionado.codigoArticuloSap.substring(0, 2) : ''

      if (serieSeleccionado.descripcionUbigeoMaquina) {
        var ubigeoEquipo = vm.ubigeos.find(e => e.descripcion === serieSeleccionado.descripcionUbigeoMaquina)
        if (ubigeoEquipo) {
          nuevaSerie.departamento = ubigeoEquipo.departamento
          nuevaSerie.provincia = ubigeoEquipo.provincia
          nuevaSerie.distrito = ubigeoEquipo.distrito

          nuevaSerie.provincias = vm.ubigeos.filter(e => e.departamento === nuevaSerie.departamento).map(e => e.provincia)
          nuevaSerie.distritos = vm.ubigeos.filter(e => e.provincia === nuevaSerie.provincia).map(e => e.distrito)
        }
      }

      vm.fetchFallas(nuevaSerie.tipoProductoMaquina)
      var nuevaSerieConInsumo = vm.recalcularInsumos(nuevaSerie)
      vm.tickets.push(nuevaSerieConInsumo)
      vm.limpiarSerie()
    },
    recalcularInsumos (ticket) {
      ticket.insumo = []
      if (ticket.tipo === 'solicitud de insumo') {
        if (ticket.grupoPedidoInsumo === 'papel') {
          ticket.insumo = [
            {
              name : 'PAPEL',
              code : 'papel',
              active: true
            }
          ]
          return ticket
        } else {
          if (['CF'].includes(ticket.tipoProductoMaquina)) {
            ticket.clasificacion = 'cafetera'
            ticket.insumo = [
              {
                name : 'BOLSA DE CAFE',
                code : 'bolsa de cafe',
                active: true
              }
            ]
          } else if (['ML', 'MT', 'PD', 'FA'].includes(ticket.tipoProductoMaquina)) {
            ticket.clasificacion = 'multifuncional'
            if (!ticket.esColor) {
              ticket.insumo.push(
                {
                  name : 'TONER COLOR - CYAN (C)',
                  code : 'toner color cyan',
                  active: true
                },
                {
                  name : 'TONER COLOR - MAGENTA (M)',
                  code : 'toner color magenta',
                  active: true
                },
                {
                  name : 'TONER COLOR - AMARILLO (Y)',
                  code : 'toner color amarillo',
                  active: true
                }
              )
            }
            ticket.insumo.push(
              {
                name : 'TONER COLOR - NEGRO (K)',
                code : 'toner color negro',
                active: true
              }
            )
          }
          return ticket
        }
      } else {
        return ticket
      }
    },
    fetchCambiarRUCCuenta (isGuardar = false) {
      var vm = this
      if (isNaN(vm.ruc)) {
        return notify(vm, 'error', 'Error', 'El numero de RUC, es invalido.')
      }

      if (vm.ruc.length < 11) {
        return notify(vm, 'error', 'Error', 'El numero de RUC no puede tener menos de 11 digitos.')
      }

      if (vm.ruc.length > 11) {
        return notify(vm, 'error', 'Error', 'El numero de RUC no puede tener mas de 11 digitos.')
      }

      if (vm.ruc === vm.rucEditCliente) {
        return notify(vm, 'error', 'Error', 'El numero de RUC ya se encuentra asignado a la cuenta.')
      }

      vm.isLoadingCambiarRuc = true
      var obj = {
        ruc : vm.rucEditCliente,
        isGuardar : isGuardar
      }

      apiPost(vm, '/usuario/actualizar/ruc', obj, function (data) {
        if (isGuardar) {
          notify(vm, 'success', 'Exito', 'Los datos del cliente se cambiaron correctamente.')
          localStorage.setItem('codigoCliente', data.cliente.codigoCliente)
          localStorage.setItem('razonSocial', data.cliente.razonSocial)
          localStorage.setItem('ruc', data.cliente.ruc)
          vm.closeDialogIsChangeCustomer()
          window.location.reload()
        } else {
          vm.nombreEditCliente = data.cliente.razonSocial
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingCambiarRuc = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.box-equipos-en-contrato
  max-height 400px
  overflow-y auto
.box-new-ticket
  max-height calc(100vh - 400px)
  min-height calc(100vh - 400px)
  overflow-y auto
.border-bottom-2px:not(:first-child):not(:last-child) {
  border-bottom: 1px solid #ccc !important;
  border-top: 1px solid #ccc !important;
}
</style>



// WEBPACK FOOTER //
// New_Ticket_Contrato_View.vue?2593889e